import React from 'react';
import styled from 'styled-components';
import Collapse, { Panel } from 'rc-collapse';
import renderHTML from 'react-render-html';
import { PRICING_FAQS } from './data/pricing-faqs';
import { FlexiRow } from '../../styles/styled';
import Colors from '../../styles/colors';

const PricingAccordion = () => {
  const getPanelHeader = faq => {
    return (
      <FlexiRow alignItems="center" justifyContent="space-between">
        <div className="question">{faq.question}</div>
        <ArrowIcon />
      </FlexiRow>
    );
  };

  return (
    <PricingTabbordion>
      {PRICING_FAQS.map((faq, i) => {
        return (
          <Collapse key={`faqs-${i}`}>
            <Panel
              header={getPanelHeader(faq)}
              headerClass="title-extra-large xs-title-extra-large no-margin alt-font-2 font-weight-400 padding-four-left padding-four-right padding-three-top padding-three-bottom xs-padding-eight"
              showArrow={false}>
              <div className="text-extra-large xs-title-small line-height-30 only-opacity-medium font-weight-400 alt-font-2 padding-four xs-padding-nine">
                {renderHTML(faq.answer)}
              </div>
            </Panel>
          </Collapse>
        );
      })}
    </PricingTabbordion>
  );
};

const ArrowIcon = styled.i`
  background: url('/images/pricing/arrow.png') center no-repeat;
  width: 25px;
  height: 25px;
  background-size: cover;

  @media (max-width: 767px) {
    width: 20px;
    height: 20px;
  }
`;

const PricingTabbordion = styled.div`
  .rc-collapse {
    border: none;
    margin-bottom: 50px;

    .rc-collapse-item {
      .rc-collapse-header {
        outline: 0;
        background: #fff;
        color: #222222;
        cursor: pointer;
        display: block;
        padding: 1rem;
        position: relative;
        user-select: none;
        box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.05);
        z-index: 2;
        line-height: initial;

        .question {
          flex: 1 1 0%;
          padding-right: 10px;
        }

        ${ArrowIcon} {
          transform: rotate(0deg);
          transition: transform 0.2s ease-in-out;
        }
      }

      &.rc-collapse-item-active {
        ${ArrowIcon} {
          transform: rotate(180deg);
        }
      }
    }
  }

  .rc-collapse-content {
    background-color: #f2f2f2;
    padding: 0;

    .rc-collapse-content-box {
      margin: 0;

      a {
        color: ${Colors.mainOrange};

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;

export default PricingAccordion;
